<template>
  <div class="PcStyle top">
    <div class="top-left" @click="goIndex">
      <img src="../assets/logo.png" alt="" width="48px" />
      <div>钱学森图书馆团队参观申请系统</div>
    </div>
    <div class="top-right" v-if="show">

      <div @click="$router.push('/ptype')" class="order">参观申请</div>
      <div @click="$router.push('/PorderCenter?type=0')" class="order">参观记录</div>
      <!-- <el-dropdown-item command="a"></el-dropdown-item> -->
      <img src="../assets/user.png" alt="" width="48px" />
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          {{this.email}}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
import { removePToken,getPToken } from "../token";
export default {
  data() {
    return {
      email:""
    };
  },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },
  created(){
    this.getUser()
  },
  methods: {
    handleCommand() {
      removePToken();
      this.$router.push("/Plogin");
    },
    goIndex() {
      if (this.show) {
        this.$router.push("/Pindex");
      }
    },
    getUser(){
    

      this.$axios.get(`/getInfo`,{
        headers:{
          'Content-Type':'application/json;charset=utf-8',
         'Authorization': getPToken()
        }
      }).then((res) => {
        this.email = res.user.email
      })
    }
  },
};
</script>
<style lang="less" scoped>
.top {
  width: 100%;
  height: 90px;
  padding: 0 20px;
  box-sizing: border-box;
  background-color: #aa2020;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  .top-left {
    display: flex;
    align-items: center;
    font-size: 20px;
    cursor: pointer;
    img {
      margin-right: 10px;
    }
  }
  .top-right {
    display: flex;
    align-items: center;
    font-size: 20px;
    .order{
      font-size: 16px;
      margin-right:20px;
      cursor: pointer;
    }
    .el-dropdown-link {
      color: #fff;
      margin-left: 10px;
      cursor: pointer;
    }
    img {
      border-radius: 50%;
    }
  }
}
</style>